import {useMemo} from 'react';
import {useVodItemByIdQuery} from '@src/Api/Graphql/gql/types.generated';
import useContentIdByEndUrl from '@src/Umbraco/Hooks/useContentIdByEndUrl';
import useParams from '@src/Hooks/useParams';
import dayjs from 'dayjs';
import {useFindProgression} from '@src/Hooks/useFindProgression';
import useDurationFactory from '@src/Hooks/useDurationFactory';

export function useVodItemData() {
  const {endUrl1, endUrl2} = useParams();
  const endUrl = `/${endUrl1}/${endUrl2}/`.replaceAll('//', '/');
  const {id, loading: loadingId} = useContentIdByEndUrl({variables: {endUrl}});
  const response = useVodItemByIdQuery({
    variables: {id},
    errorPolicy: 'all',
    skip: !id,
    fetchPolicy: 'cache-first',
  });
  const loading = response.loading || loadingId;
  const {findDuration} = useFindProgression();
  const {parseDuration} = useDurationFactory();

  const {vodItem, listCategory} = useMemo(() => {
    console.log('useVodItemData response:', response);
    const _vodItem = response?.data?.vODItem;
    const _list: string[] = [];
    if (_vodItem) {
      if (_vodItem.public) {
        if (typeof _vodItem.public === 'string') {
          _list.push(_vodItem.public);
        }
      }
      const _duration = findDuration(_vodItem.id);
      if (_vodItem.length || _duration) {
        const dur = parseDuration(_duration || _vodItem.length || 0);
        _list.push(dur);
      }
      if (_vodItem.releaseDate) {
        const year = dayjs(_vodItem.releaseDate).format('YYYY');
        if (year !== '1') {
          _list.push(year);
        }
      }
    }
    return {vodItem: _vodItem, listCategory: _list};
  }, [response]);

  return {vodItem, listCategory, loading};
}
